import { useParams } from "react-router-dom";

import Box from "ds/components/Box";
import ViewHeaderTitle from "components/ViewHeader/Title";
import ViewHeader from "components/ViewHeader";
import useTitle from "hooks/useTitle";
import useBreadcrumbs from "components/Breadcrumbs/useBreadcrumbs";
import ViewHeaderWrapper from "components/ViewHeader/Wrapper";
import NotFoundPage from "components/error/NotFoundPage";
import useErrorHandle from "hooks/useErrorHandle";
import useUserGuideGroup from "shared/UserGuides/useUserGuideGroup";
import UserGuideGroup from "components/UserGuideGroup";
import UserGuideGroupSkeleton from "components/UserGuideGroup/Skeleton";

const LaunchPadUserGuidesGroup = () => {
  const { userGuideGroupId } = useParams();

  const { userGuideGroup, loading, error } = useUserGuideGroup({ id: userGuideGroupId! });

  const title = userGuideGroup?.name;

  useTitle(`LaunchPad · ${title}`);

  useBreadcrumbs([
    {
      title: "LaunchPad",
      link: "/launchpad",
    },
    {
      title: title || "User Guides Group",
    },
  ]);

  const ErrorContent = useErrorHandle(error);

  if (ErrorContent) {
    return ErrorContent;
  }

  if (!loading && !userGuideGroup) {
    return <NotFoundPage />;
  }

  return (
    <>
      <ViewHeader>
        <ViewHeaderWrapper>
          <ViewHeaderTitle>{title}</ViewHeaderTitle>
        </ViewHeaderWrapper>
      </ViewHeader>
      <Box surfaceColor="primary">
        {loading && !userGuideGroup && <UserGuideGroupSkeleton />}
        {userGuideGroup && <UserGuideGroup userGuideGroup={userGuideGroup} />}
      </Box>
    </>
  );
};

export default LaunchPadUserGuidesGroup;
